import { Box } from "@mui/material";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { ResourceExplorerGroupingNullable } from "@/services/cloudchipr.api";
import { BillingExplorerGranularCostCell } from "@/components/pages/common/billing-explorer/components/BillingExplorerGranularCostCell";
import { ResourceExplorerGranularDateHeadersCell } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/header-cell-components/ResourceExplorerGranularDateHeadersCell";
import { getBillingExplorerLabelColDef } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/column-defs/getBillingExplorerLabelColDef";
import { ResourceExplorerTotalCostColumnHeaderCell } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/header-cell-components/ResourceExplorerTotalCostColumnHeaderCell";

export const getBillingExplorerGranularViewColumnDefs = (
  grouping: ResourceExplorerGroupingNullable,
  keys?: string[],
): ColDef[] => {
  if (!keys) {
    return [];
  }

  const columns: ColDef[] = [
    getBillingExplorerLabelColDef({
      sortable: grouping !== "none",
      pinned: true,
    }),
    {
      field: "total_cost",
      suppressMovable: true,
      pinned: "left",
      minWidth: 180,
      headerComponentParams: {
        innerHeaderComponent: ResourceExplorerTotalCostColumnHeaderCell,
      },
      cellRenderer: ({ data }: ICellRendererParams) => {
        return (
          <Box pr={3.5}>
            <BillingExplorerGranularCostCell
              cost={data.total_cost}
              trend={data.trend}
            />
          </Box>
        );
      },
    },
  ];

  keys.forEach((key, index) => {
    columns.push({
      colId: `${key}_${index}`,
      minWidth: 180,
      field: `${key}.cost`,
      headerComponentParams: {
        innerHeaderComponent: () => (
          <ResourceExplorerGranularDateHeadersCell value={key} />
        ),
      },
      cellRenderer: ({ data }: ICellRendererParams) => {
        const trend = data[key]?.trend ?? null;
        const cost = data[key]?.cost;
        const trendTooltip = data?.trendTooltip;

        return (
          <Box pr={3.5}>
            <BillingExplorerGranularCostCell
              cost={cost}
              trend={trend}
              trendTooltip={trendTooltip}
            />
          </Box>
        );
      },
    });
  });

  return columns;
};
